var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container",style:({
  'margin-top': _vm.cc.margin_top + 'px',
  'margin-bottom': _vm.cc.margin_bot + 'px'
})},[(_vm.cc.title)?_c('h2',{staticClass:"text-title",style:({'color': _vm.gc.text_color, 'color': _vm.cc.color || _vm.gc.main_color,})},[_vm._v(_vm._s(_vm.cc.title))]):_vm._e(),_c('div',{ref:"text-list",staticClass:"text-list"},_vm._l((_vm.cc.text_list),function(item){return _c('p',{key:item,staticClass:"text",style:({
      'color': _vm.cc.color || _vm.gc.main_color,
      'opacity': _vm.cc.opacity,
      'font-size': _vm.cc.font_size + 'px',
      'line-height': _vm.cc.line_height + 'px',
      'text-align': _vm.cc.align || 'left'
    }),domProps:{"innerHTML":_vm._s(item)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }